import { StyledSpacer } from "./styles";

export type SpacerProps = {
  mt: { xs: number; sm?: number; md?: number; lg?: number; xl?: number };
};

export const Spacer = ({ mt }: SpacerProps) => {
  return <StyledSpacer mt={mt} />;
};
